// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/Login/Login";
import Admin from "./Components/Admin/Admin"; // ✅ Admin added
import Dashboard from "./Components/Dashboard/Dashboard";
import Test from "./Components/Test/Test";
import Result from "./Components/Result/Result";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false); // ✅ Optional admin session
  const [questions, setQuestions] = useState([]);
  const [candidateInfo, setCandidateInfo] = useState({});

  const handleLogin = (email) => {
    setUserEmail(email);
    setIsLoggedIn(true);
  };

  const handleAdminLogin = () => {
    setIsAdminLoggedIn(true);
  };

  return (
    <Router>
      <Routes>
        {/* Default route */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            isLoggedIn ? (
              <Dashboard
                setQuestions={setQuestions}
                setCandidateInfo={setCandidateInfo}
                userEmail={userEmail}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Test Page */}
        <Route
          path="/test"
          element={
            isLoggedIn ? (
              <Test
                questions={questions}
                candidateInfo={candidateInfo}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Admin Route */}
        <Route
          path="/admin"
          element={
            isAdminLoggedIn ? (
              <div style={{ padding: "2rem", textAlign: "center" }}>
                <h1>✅ Welcome Admin</h1>
                <p>This is a protected admin dashboard.</p>
              </div>
            ) : (
              <Admin onAdminLogin={handleAdminLogin} />
            )
          }
        />

        <Route path="/admin/results" element={<Result />} />
        
      </Routes>
    </Router>
    // <>
    //   <Test/>
    // </>
  );
}

export default App;
